import * as http from './http';
import ApiService from './service';
import { Plan, RequestPlan, SendTask } from '../models';

export default class PlanService extends ApiService {
  planEndPoint = '/v1/plans/';
  updatePlanStatusEndPoint = '/v1/plans/approve/';
  public async createPlan(data: RequestPlan, status?: string): Promise<Plan> {
    const url = `${this.apiDomain}${this.planEndPoint}${
      status ? `?status=${status}` : ''
    }`;

    const response = await http.post<RequestPlan, Plan>(url, data, this.token);
    return response.data;
  }
  public async updatePlan(
    data: RequestPlan,
    planId?: string,
    status?: 'Draft'
  ): Promise<Plan> {
    const url = `${this.apiDomain}${this.planEndPoint}${planId}${
      status ? `?status=${status}` : ''
    }`;
    const response = await http.post<RequestPlan, Plan>(url, data, this.token);
    return response.data;
  }
  public async updatePlanStatus(
    data: SendTask[],
    planId?: string
  ): Promise<{ _id: string }> {
    const url = `${this.apiDomain}${this.updatePlanStatusEndPoint}${planId}`;
    const response = await http.post<{ tasks: SendTask[] }, { _id: string }>(
      url,
      { tasks: data },
      this.token
    );
    return response.data;
  }
}
